import script from "./fwxy.vue?vue&type=script&lang=ts&setup=true"
export * from "./fwxy.vue?vue&type=script&lang=ts&setup=true"

import "./fwxy.vue?vue&type=style&index=0&id=d6687b6a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6687b6a"]])

export default __exports__